
const questions = ['Did you learn anything new?', 'Would you consider a career in this field?'];
const possibleAnswers = ["YES","NO"];
const questionAnswers = {};

export function resetQuestionAnswers() {
	for (let key of Object.keys(questionAnswers)) {
		delete questionAnswers[key];
	}
}

function displayAnswers(parentElement, question, extraShit) {

	for (let answer of possibleAnswers) {
		let answerButton = document.createElement('button');
		answerButton.style.paddig = '5px';
		answerButton.style.fontSize = '12px';
		answerButton.style.color = 'white';
		answerButton.style.backgroundColor = 'blue';
		answerButton.style.borderRadius = '5px';
		answerButton.style.cursor = 'pointer';				
		answerButton.style.margin = '4px';				
		answerButton.onclick = (e) => {
			questionAnswers[question] = answer;
			parentElement.remove();
			extraShit(questionAnswers);
		};

		answerButton.textContent = answer;

		parentElement.appendChild(answerButton);
	}
}

function addQuestions(parentElement, extraShit) {
	
	for (let question of questions) {
		let questionWrapper = document.createElement('div');
		questionWrapper.style.flex = '1';
		parentElement.appendChild(questionWrapper);

		let questionElement = document.createElement('h3');
		questionElement.textAlign = 'center';
		questionElement.innerText = question;
		questionWrapper.appendChild(questionElement);

		displayAnswers(questionWrapper, question, extraShit);
	}
}

export function getAnswers() {
	return questionAnswers;
}

export function addQuestionsElement(parentElement, extraShit) {

	let questionsWrapper = document.createElement('div');
	
	parentElement.appendChild(questionsWrapper);

	let questionsElement = document.createElement('div');
	questionsElement.style.backgroundColor = 'white';
	questionsElement.style.display = 'flex';
	questionsElement.style.flexDirection = 'row';
	questionsElement.style.borderRadius = '10px';
	questionsElement.style.padding = '10px';

	questionsWrapper.appendChild(questionsElement);

	addQuestions(questionsElement, extraShit);
}
